import React from "react";


import AppBox from "./components/AppBox";

function App() {
  return (
    <>
       <AppBox />
    </>
  );
}

export default App;
